import uniq from 'lodash/uniq';

import { useMutation } from '@gogame/query';

import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/constants';
import {
  loadConceptFamily,
  updateConceptFamily,
} from 'scenes/Gallery/GalleryPage/ConceptFamilies/sources/conceptFamilies';
import * as ADD_CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/Concepts/BatchAddToConceptFamilyForm/constants';

import { addToConceptFamily } from '../queryKeyFactory';

export const useAddToConceptFamily = () => {
  const handleAddToConceptFamily = async ({
    [ADD_CONCEPT_FAMILY.CONCEPT_FAMILY]: conceptFamilyId,
    [ADD_CONCEPT_FAMILY.CONCEPTS]: conceptIds,
  }) => {
    const conceptFamily = await loadConceptFamily({
      id: conceptFamilyId,
    });
    conceptFamily[CONCEPT_FAMILY.CONCEPTS] = uniq([
      ...conceptFamily[CONCEPT_FAMILY.CONCEPTS],
      ...conceptIds,
    ]);
    if (!conceptFamily[CONCEPT_FAMILY.ORIGINAL_CONCEPT]) {
      conceptFamily[CONCEPT_FAMILY.ORIGINAL_CONCEPT] =
        conceptFamily[CONCEPT_FAMILY.CONCEPTS][0];
    }

    await updateConceptFamily(conceptFamily);
    return { id: conceptFamilyId };
  };

  const removeMutation = useMutation(
    addToConceptFamily(),
    handleAddToConceptFamily
  );
  return [removeMutation.mutateAsync, removeMutation];
};
